import { IDevise } from '@core-lib/models';

export function getDeviseById(deviseId: IDevise['id'], devises: IDevise[]): IDevise {
	return devises.find(d => d.id === deviseId);
}
